import * as React from 'react'
import { BodyWithMenu } from '../../components/organisms/Menu'
import { EditInvestor } from '../../components/organisms/EditInvestor'
import { getInvestments, resetInvestor } from '../../globals/ApiHooks'
import { TranslatedTerms } from '../../globals/TranslatedTerms';
import { DangerButton } from '../../components/atoms/Inputs';
import { lang } from '../../globals/Translations';
import AnalyticsHooks from '../../globals/AnalyticsHooks';
import { ActivityType } from '../../shared/Activity';
import { IsInvestmentLeagallyBinding } from '../../shared/BusinessIntelligence';

export const ProfilePage: React.FC = () => {
  const [showDeleteInvestor, setShowDeleteInvestor] = React.useState(false)

  const getInvestment = async () => {
    const investments =  await getInvestments()
    const legallyBinding = investments?.filter(IsInvestmentLeagallyBinding)
    if(legallyBinding && legallyBinding.length === 0) setShowDeleteInvestor(true)
  }

  AnalyticsHooks.LogActivity(ActivityType.PROFILE_VISIT)

  return (
    <BodyWithMenu loading={false}>
      <h1>{lang(TranslatedTerms.PROFILE)}</h1>
      <EditInvestor showPageInformation loadingCompleted={getInvestment}/>
      {showDeleteInvestor && <div style={{ display:'flex', flexDirection:'row-reverse', marginTop: 40}}>
        <DangerButton title={TranslatedTerms.RESET_USER} handleClick={resetInvestor}
          description={TranslatedTerms.RESET_USER_DESCRIPTION} warningDescription={TranslatedTerms.RESET_USER_WARNING_DESCRIPTION} />
      </div>}
    </BodyWithMenu>
  )
};
